export default __webpack_public_path__ + "static/media/2163.368787dc.png";